import React, { Fragment, useContext, useState } from 'react';
import { MessageContext } from '../../contexts/messageContext';
import binocularsIcon from '../../assets/svg/binoculars.svg';
import envelopeOpen from '../../assets/svg/envelope-open-message-primary.svg';
import checkedCircle from '../../assets/svg/check-circle-light.svg'

interface CreativeCardProps {
  name: string;
  avatar: string;
  location: string;
  bio: string;
  professions: string[];
  collaborationRoles: string[];
  status: string;
  similarityScore?: number;
  onInvite?: () => void;
  user?: any;
  isProjectOwner?: boolean;
  currentUser?: any;
}

const CreativeCard: React.FC<CreativeCardProps> = ({
  name,
  avatar,
  bio,
  professions,
  collaborationRoles,
  status,
  user,
  isProjectOwner
}) => {
  const { actions } = useContext(MessageContext);
  const [showAllRoles, setShowAllRoles] = useState(false);

  const handleMessageClick = async () => {
    if (user && actions?.handleSelectOtherUser) {
      try {
        const transformedUser = {
          id: user.id,
          name: user.name || 'Unknown Name',
          avatar: user.avatar || 'https://www.gravatar.com/avatar/?d=mp',
          bio: user.bio || 'No bio available',
          location: user.location || 'Location not specified',
          userConfirmed: true,
          profile: {
            name: user.name || 'Unknown Name',
            bio: user.bio || 'No bio available',
            location: user.location || 'Location not specified'
          }
        };
        await actions.handleSelectOtherUser(transformedUser);
      } catch (error) {
        console.error('Message error:', error);
      }
    }
  };

  if (!isProjectOwner) return null;

  const capitalizedStatus = status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();

  return (
    <div className="column is-4">
      <div className="creative-card" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div className={`creative-status ${status.toLowerCase()}`}>
          <span className="status-dot" />
          <span>{capitalizedStatus}</span>
        </div>
        <div className="creative-info" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <img src={avatar} alt={name} className="creative-avatar" />
          <h4 className="creative-name" style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            width: '100%',
            margin: '8px 0'
          }}>{name}</h4>
          <div className="creative-tags" style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '4px',
            maxWidth: '100%',
            padding: '0 8px'
          }}>
            {professions.map((profession, index) => (
                <span key={index} className="tag" style={{
                  marginBottom: '4px',
                  maxWidth: '100%',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}>
                  <Fragment key={profession}>
                    <div className='has-justify-content-space-between'>
                      <img
                        src={checkedCircle}
                        alt="icon binoculars"
                        className="image is-16x16 is-inline"
                      />
                      <span style={{ marginLeft: '4px' }}>{profession}</span>
                    </div>
                  </Fragment>
                </span>
            ))}
          </div>
          <p className="creative-bio" style={{ flex: 1 }}>{bio}</p>
          <div style={{ marginTop: 'auto', padding: '0 8px' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                <img
                    src={binocularsIcon}
                    alt="icon binoculars"
                    className="image is-16x16 is-inline"
                    style={{ marginRight: '4px' }}
                />
                <span className="creative-collab has-text-weight-semibold">Want to collaborate with</span>
            </div>
            <div style={{ position: 'relative' }}>
              <p className="creative-roles" style={{
                maxWidth: '100%',
                overflow: 'hidden',
                textOverflow: showAllRoles ? 'unset' : 'ellipsis',
                marginBottom: '12px',
                lineHeight: '1.5',
                maxHeight: showAllRoles ? 'none' : '1.5em',
                whiteSpace: showAllRoles ? 'normal' : 'nowrap'
              }}>
                {collaborationRoles.join(', ')}
              </p>
              {collaborationRoles.length > 0 && (
                <button
                  onClick={() => setShowAllRoles(!showAllRoles)}
                  className="button is-small is-text has-text-primary"
                  style={{
                    padding: '0',
                    height: 'auto',
                    fontSize: '0.8rem',
                    marginTop: '-8px',
                    marginBottom: '12px'
                  }}
                >
                  {showAllRoles ? 'See less' : 'See more'}
                </button>
              )}
            </div>
            <div className="creative-actions">
              <button
                className="button is-light is-fullwidth has-text-weight-semibold has-text-primary"
                onClick={handleMessageClick}
              >
                <Fragment>
                  <img src={envelopeOpen} alt="icon binoculars" className="image is-16x16 is-inline"
                    style={{ filter: 'invert(27%) sepia(93%) saturate(1824%) hue-rotate(230deg) brightness(89%) contrast(101%)' }}
                  />
                  <span>Message</span>
                </Fragment>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreativeCard;